module.exports = __webpack_public_path__ + "static/media/select_icon.76b9ed70.svg";